import { Card } from "@/components/ui/card";

function About() {
    return (
        <div className="flex min-h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <article className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        ABOUT WELNIDO
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Why we exist.
                    </h1>

                    <p className="lead text-center text-neutral-500">
                        Putting trusted professionals within easy reach. Where
                        clarity meets care.
                    </p>

                    <h2 id="what-welnido-is" className="text-2xl">
                        What Welnido is
                    </h2>

                    <p>
                        Welnido is a UK platform for finding and booking trusted
                        private clinicians: physiotherapists, GPs, therapists,
                        specialists, and more. Every professional on Welnido is
                        properly vetted: registration checked against their
                        professional body, DBS checked, and insured. Patients
                        search, compare and book in minutes; clinicians get a
                        calm, professional home for their practice without the
                        admin burden.
                    </p>

                    <h2 id="what-started-it" className="text-2xl">
                        What started it
                    </h2>

                    <p>
                        Welnido began with a familiar frustration: finding the
                        right private clinician meant scattered Google searches,
                        out-of-date directories, unanswered phones and no easy
                        way to know who was properly qualified and actually
                        available. Booking a haircut was easier than booking a
                        physiotherapist. We believed finding care should feel
                        clear and calm, not like navigating a maze. So we built
                        the single, steady point of clarity we wished existed.
                    </p>

                    <h2 id="our-founders" className="text-2xl">
                        Our founders
                    </h2>

                    <p>
                        Welnido was founded by people who have seen both sides
                        of the problem: what patients need to feel safe and
                        looked after, and what clinicians need to do their best
                        work.
                    </p>

                    <Card size="lg" className="mb-5 block bg-sky-50/25">
                        <div className="flex items-center gap-x-4">
                            <div className="flex size-16 items-center justify-center rounded-full bg-darkgreen-500 text-2xl font-bold text-white">
                                C
                            </div>
                            <div>
                                <h3 className="mt-2 mb-0 text-2xl/5">
                                    Catherine
                                </h3>
                                <span>
                                    <small>Co-founder</small>
                                </span>
                            </div>
                        </div>
                        <p>
                            "I'm a specialist nurse, and I've spent my whole
                            career in the NHS. I've seen first-hand the pressure
                            it's under (brilliant people doing everything they
                            can with too little time), and I've also seen where
                            private care could work alongside it, making the
                            patient journey smoother rather than competing with
                            it. That's really where Welnido started. Knowing
                            healthcare from the inside meant I understood both
                            sides: what patients need to feel safe and looked
                            after, and what clinicians need to do their best
                            work without drowning in admin."
                        </p>
                    </Card>

                    <Card size="lg" className="block bg-sky-50/25">
                        <div className="flex items-center gap-x-4">
                            <div className="flex size-16 items-center justify-center rounded-full bg-green-600 text-2xl font-bold text-white">
                                A
                            </div>
                            <div>
                                <h3 className="mt-2 mb-0 text-2xl/5">
                                    Annabel
                                </h3>
                                <span>
                                    <small>Co-founder</small>
                                </span>
                            </div>
                        </div>
                        <p>
                            "I spent my career in banking and finance: years of
                            corporate work with businesses of all sizes,
                            building the kind of analytical depth that comes
                            from looking closely at how things really operate
                            rather than how they're presented. I was good at it,
                            and I loved it. Then I became seriously ill, ended
                            up in hospital, and came out the other side with a
                            sudden diagnosis and a newborn baby. Trying to
                            arrange the care I needed in that state was
                            genuinely one of the hardest things I've done: no
                            energy, no clear route through, a million questions,
                            a system which saved my life but couldn't help me
                            get the answers I needed, and a tiny person
                            depending on me while I sat on hold or scrolled
                            through websites trying to work out who I could
                            trust. Welnido is the thing I wish I'd had then: a
                            clear, straightforward way to find a trusted
                            clinician and get on with getting better."{" "}
                        </p>
                    </Card>
                </article>
            </div>
        </div>
    );
}

export default About;
